import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardBacklog1Route: InvariantJiraRoute = {
	name: 'rapidboard-backlog',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=(planning|planning.nodetail)'],
};
